import { render, staticRenderFns } from "./EnemGradesForm.vue?vue&type=template&id=2c6152b3&scoped=true&"
import script from "./EnemGradesForm.vue?vue&type=script&lang=ts&"
export * from "./EnemGradesForm.vue?vue&type=script&lang=ts&"
import style0 from "./EnemGradesForm.vue?vue&type=style&index=0&id=2c6152b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6152b3",
  null
  
)

export default component.exports